import { CapoPlugin } from "/vercel/path0/node_modules/.pnpm/@unhead+vue@1.11.10_vue@3.5.12_typescript@5.6.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];